import React from "react";
import { NodeSizeButton } from "./../_shared/node-size-button/node-size-button.js";
import { isVisibleOnlyOnDesktop } from "./../_shared/resolvers/is-visible-only-on-desktop.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./../editor-common/index.js";
import { handleFileUpload } from ".//handle-file-upload.js";
import { NodeAlignmentButton } from "./../toolbars-v3/index.js";
import { FILE_BUTTONS } from "./consts.js";
const getToolbarButtons = (config, services) => {
  const {
    context: { isMobile }
  } = services;
  return [
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(
        NodeSizeButton,
        {
          id: FILE_BUTTONS.size,
          toolbarItem,
          options: ["SMALL", "CONTENT"]
        }
      )
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isVisibleOnlyOnDesktop(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: FILE_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isVisibleOnlyOnDesktop(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      tooltip: "FileUploadReplaceButton_tooltip",
      command: ({ attributes: { selectedNode }, publicCommands }) => {
        handleFileUpload({ config, services, publicCommands, nodeId: selectedNode.attrs.id });
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};
export {
  getToolbarButtons
};
//# sourceMappingURL=getToolbarButtons.js.map
